import React, { useState } from 'react';
import styled from 'styled-components';
import { CheckboxDropdownOption } from '../../Dropdown';
import ThinDivider from '../../ThinDivider';
import { PrimaryButton } from '../../Button';
import { IInlineMultiSelectMenuOption } from './types';

interface IProps<ValueType> {
  options: IInlineMultiSelectMenuOption<ValueType>[];
  selectedKeys: ValueType[];
  onSubmit: (selection: ValueType[]) => void;
}

const SubmitAction = styled(PrimaryButton)`
  width: 100%;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
`;

const InlineMultiSelectOptions = <ValueType,>({
  options,
  selectedKeys,
  onSubmit,
}: IProps<ValueType>) => {
  const [selection, setSelection] = useState<ValueType[]>(selectedKeys);

  const toggleAll = (allIsChecked: boolean) => {
    setSelection(allIsChecked ? [] : options.map((option) => option.value));
  };
  const toggleOption = (value: ValueType, checked: boolean) => {
    setSelection((prevState) => {
      if (checked) {
        return prevState.filter((stateValue) => stateValue !== value);
      } else {
        return [...prevState, value];
      }
    });
  };

  const handleSubmit = () => {
    onSubmit(selection);
  };

  const allIsChecked =
    options.length > 0 && selection.length === options.length;

  return (
    <>
      <CheckboxDropdownOption
        label={'All'}
        isChecked={allIsChecked}
        onClick={() => toggleAll(allIsChecked)}
      />
      <ThinDivider layout="horizontal" size="full" />
      {options.map((option) => {
        const { label, value } = option;
        const checked = selection.includes(value);

        return (
          <CheckboxDropdownOption
            key={`inline-multi-${value}`}
            label={label}
            isChecked={checked}
            onClick={() => toggleOption(value, checked)}
          />
        );
      })}
      <SubmitAction
        type="button"
        onClick={handleSubmit}
        trackContext="inline multi select"
        trackAction="confirm"
      >
        Confirm
      </SubmitAction>
    </>
  );
};

export default InlineMultiSelectOptions;
